type ValidStage = "prod" | "dev" | "local"

type AppConfig = {
  stage: ValidStage
  AWS_COGNITO_USER_POOL_ID: string
  AWS_COGNITO_USER_POOL_WEB_CLIENT_ID: string
  STRIPE_PK: string
  FB_APP_ID?: string
  DEPLOY_HOSTNAME: string
  COGNITO_OAUTH_DOMAIN: string
  SENTRY_DSN: string
  GA_TRACKING_ID?: string
}

const configs: { [key in ValidStage] : AppConfig} = {
  "prod": {
    stage: "prod",

    AWS_COGNITO_USER_POOL_ID: "us-west-2_wdV06ddNS",
    AWS_COGNITO_USER_POOL_WEB_CLIENT_ID: "21hebe11k6vmoqgrnqhu7k2sog",
    GA_TRACKING_ID: "UA-133278638-3",
    STRIPE_PK: "pk_live_y1D2foyPmByf6qPBJhqi8VAr",
    FB_APP_ID: "545298355963636",
    DEPLOY_HOSTNAME: "app.speech2.io",
    COGNITO_OAUTH_DOMAIN: "auth.speech2.io",
    SENTRY_DSN: "https://566776ae3ccb4cac85ca5bd97d68d60b@sentry.io/1432919",
  },
  "dev": {
    stage: "dev",

    AWS_COGNITO_USER_POOL_ID: "us-west-2_phVEEW9pr",
    AWS_COGNITO_USER_POOL_WEB_CLIENT_ID: "79q6dv8nco8o32obaerl7m09nk",
    GA_TRACKING_ID: "UA-133278638-5",
    STRIPE_PK: "pk_test_Lmgy9TAn0sD23edzMIPe1y8F",
    FB_APP_ID: "843086432703007",
    DEPLOY_HOSTNAME: "app.s2.aoeu.club",
    COGNITO_OAUTH_DOMAIN: "speech2-dev.auth.us-west-2.amazoncognito.com",
    SENTRY_DSN: "https://566776ae3ccb4cac85ca5bd97d68d60b@sentry.io/1432919",
  },
  "local": {
    stage: "local",

    AWS_COGNITO_USER_POOL_ID: "us-west-2_phVEEW9pr",
    AWS_COGNITO_USER_POOL_WEB_CLIENT_ID: "79q6dv8nco8o32obaerl7m09nk",
    STRIPE_PK: "pk_test_Lmgy9TAn0sD23edzMIPe1y8F",
    // FB_APP_ID: "843086432703007",
    DEPLOY_HOSTNAME: "localhost:3000",
    COGNITO_OAUTH_DOMAIN: "speech2-dev.auth.us-west-2.amazoncognito.com",
    SENTRY_DSN: "https://566776ae3ccb4cac85ca5bd97d68d60b@sentry.io/1432919",
  }
}

export default configs[process.env.REACT_APP_STAGE as ValidStage]
